export default __webpack_public_path__ + "static/media/corner.3e26a3f0.svg";